import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/id';

dayjs.extend(utc);
dayjs.extend(timezone);

let currentClientTz = 'UTC';

export const setDayjsTimezone = (clientTz = 'Asia/Jakarta') => {
	if (clientTz === '+00:00') clientTz = 'UTC';

	dayjs.tz.setDefault(clientTz);
	currentClientTz = clientTz;
};

export const getCurrentClientTz = () => currentClientTz;
export const fullDateTimeWithTz = (time: dayjs.Dayjs) => {
	return time.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

export default dayjs;
